import randomizeArray from "../utils/randomizeArray";

export default function useLetterShuffle() {

    const array = randomizeArray([1,2,3,4,5,6]);

    return array;

}